import classes from "./Block.module.css";

const Block = props => {
    const blockClasses = `${classes.block} 
    ${props.value === "X" ? classes["block-red"] : props.value === "O" ? classes["block-blue"] : ""} 
    ${props.winning ? classes["block-winning"] : ""} 
    ${props.gameover && !props.value ? classes["block-inactive"] : ""}` 

    return <div id={props.id} className={blockClasses}></div>
}

export default Block;